import './index.scss'
import './i18n/config'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { RouterProvider } from 'react-router-dom'

import router from './app/router'
import { ProvideAuth } from './aws/useAuth'
import ReCaptchaProvider from './google/ReCaptchaProvider'

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <ProvideAuth>
      <ReCaptchaProvider>
        <HelmetProvider>
          <RouterProvider router={router} />
        </HelmetProvider>
      </ReCaptchaProvider>
    </ProvideAuth>
  </React.StrictMode>
)
